import React from 'react';
import { Typography, withStyles } from '@material-ui/core';

const styles = (theme) => ({
  container: {
    borderBottom: '1px solid rgba(125, 136, 154, 0.1)',
    margin: theme.spacing(3, 0, 5),
  },
  typography: {
    color: '#555',
    fontSize: '30px',
    fontWeight: 'bold',
    paddingBottom: theme.spacing(1),
  },
});

class MainTitle extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <Typography className={classes.typography}>{this.props.children}</Typography>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(MainTitle);
